// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_Wm1","cls2":"ResearchExamples-cls2_ajj ResearchExamples-cls1_Wm1"};